// Single source of truth for the student app's left navigation.
// Used by BOTH the dashboard shell (StudentApp) and the in-lesson
// main-menu rail/drawer (LearnNowPage) so the two sidebars can never
// drift apart.
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutGrid, BookOpen, Library, Wallet, Settings, Trophy,
  ClipboardList, BarChart3,
} from 'lucide-react';

export const NAV_ITEMS = [
  { to: 'desk', label: 'Student Desk', icon: LayoutGrid, testid: 'nav-desk' },
  { to: 'mydesk', label: 'MyDesk · Classes', icon: BookOpen, testid: 'nav-mydesk' },
  { to: 'assignments', label: 'Assignments', icon: ClipboardList, testid: 'nav-assignments' },
  { to: 'hub', label: 'DeskeyHUB', icon: Library, testid: 'nav-hub' },
  { to: 'analytics', label: 'Insights & Score', icon: BarChart3, testid: 'nav-analytics' },
  { to: 'badges', label: 'Badges & Trophies', icon: Trophy, testid: 'nav-badges' },
  { to: 'credits', label: 'Credits & Recharge', icon: Wallet, testid: 'nav-credits' },
  { to: 'settings', label: 'Settings', icon: Settings, testid: 'nav-settings' },
];

// `onNavigate` (optional) fires on every link click — drawers pass their
// close handler so picking a destination also dismisses the overlay.
export function StudentSidebar({ onNavigate }) {
  return (
    <nav className="space-y-1" data-testid="student-sidebar">
      {NAV_ITEMS.map(it => (
        <NavLink key={it.to} to={`/student/${it.to}`}
          data-testid={it.testid}
          onClick={onNavigate}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-2xl text-sm font-semibold transition-all ${isActive ? 'text-white' : 'opacity-80 hover:opacity-100 hover:bg-black/5'}`
          }
          style={({ isActive }) => isActive ? { background: 'var(--st-primary)' } : {}}>
          <it.icon className="w-4 h-4" />
          {it.label}
        </NavLink>
      ))}
    </nav>
  );
}
